module["exports"] = [
  "кв. ###"
];
